module.exports = __webpack_public_path__ + "static/media/12_profile_picture.43c69895.png";